import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { List, Typography } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import PaymentImage from './PaymentImage'
import { getDisplayName } from '../hooks/pay';

const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
   // backgroundColor:'red'
  },


  rowMethod: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
    //backgroundColor:'yellow'
  },


  rowInput: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    //backgroundColor:'yellow'
  },

  icon: {
    width: '15%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor:'yellow'
  },
  method: {
    width: '65%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    padding: theme.spacing(0.5),
    //backgroundColor:'red'
  },

  switch: {
    width: '20%',
  },



}));




export default function PaymentMethod(props) {
  const classes = useStyles();
  const { method, onChange, strings } = props;
 // console.debug("PaymentMethod:", method);

  const handleChange = (event) => {
    const status = event.target.checked;
    if (onChange && status != method.checked) {
      const value = {
        id: method.id,
        checked: status
      }
      onChange(value);
    }

  }

  const id = `switch-list-label-${method.id}`


  return (
    <div className={classes.root}>
      <div className={classes.rowMethod}>
        <div className={classes.icon}>
          <PaymentImage
              imageUrl={method.iconUrl}
              imageName = {method.name}
          />
        </div>
        <div className={classes.method}>
          <Typography variant='body1' > {method.name} </Typography>
        </div>
        <div className={classes.switch}>
          <Switch
            edge="end"
            onChange={handleChange}
            checked={method.checked}
            inputProps={{ 'aria-labelledby': id }}
            color="accent"
          />
        </div>
      </div>
      
    </div>
  );
}
